import { IEventsVehicleHistory } from "typings/global";
import { DrawerStatusEnum, TabPaneStatusEnum } from "typings/global.types";

export type IItems = {
  id: number;
  carrier: string;
  vehiclePlate: string;
  trailersplate: string[];
  processId?: number;
  process: string;
  eventTime?: string;
  vehicleEntryAuthorizationStatus: number;
  saleChannelDescription?: string;
  saleChannelId?: number;
  hasWarning: boolean;
  gateEventId: number;
  local: number;
  documents: string[];
  vehicleStepStatus: number;
  lenghtOfStay: string;
  serviceStartTime: string;
  serviceFinishTime: string;
  hasActiveTag: boolean;
};

export type IAttendanceItems = {
  id: number;
  carrier: string;
  vehiclePlate: string;
  trailersplate: string[];
  process: string;
  local: string;
  eventTime: string;
  scheduling: string;
};

export interface IRegisterData {
  items: {
    id: number;
    carrier: string;
    vehiclePlate: string;
    trailersPlates?: string[];
    processId?: number;
    process: string;
    eventTime?: string;
    gateEventId: number;
    vehicleEntryAuthorizationStatus?: number;
    saleChannelDescription?: string;
    saleChannelId?: number;
    hasWarning: boolean;
    serviceStartTime: string;
    serviceFinishTime: string;
    eventType: number;
    documents: string[];
    vehicleStepStatus: number;
    lenghtOfStay: string;
    hasActiveTag: boolean;
  }[];
}

export interface IAttendanceFilter {
  itemsByPage: number;
  pageIndex: number;
  orderBy?: string;
}

export interface IAttendanceFilterOptions {
  processId: number[];
  saleChannelId: number[];
  status: number;
}

export interface ISummaryData {
  presented: number;
  averageTimePresented: string | null;
  released: number;
  notReleased: number;
  actives: number;
  averageTimeActives: string | null;
  waitingInOperation: number;
  inOperation: number;
  finishOperation: number;
  warningFinishOperation: number;
  inRadiusWithCheckin: number;
  inRadiusWithoutCheckin: number;
}

export interface IVehicleStatusList {
  id: number;
  description: string;
}

export interface IOrderItems {
  code: string;
  description: string;
  unitOfMeasurement: string;
  orderNumber: string;
  quantity: number;
}

export interface IItemsCheckin {
  documentNumber: string;
  orderItems: IOrderItems[];
}

export interface IOrderItemsDataTable {
  code: string;
  description: string;
  quantity: string;
  orderNumber: string;
}

export interface IItemsCheckinDataTable {
  documentNumber: string;
  orderItems: IOrderItemsDataTable[];
}

export interface IAttendanceState {
  isLoading: boolean;
  isLoadingTable: boolean;
  isLoadingSummary: boolean;
  activeSummaryData: ISummaryData;
  disabledButtonReleaseVehicle: boolean;
  disabledButtonSaveVehicle: boolean;
  vehicleEntryAuthorizationRegisterActive?: Array<IEventsVehicleHistory>;
  visibleDrawerViewCheckinRegisterAttendance: boolean;
  visibleDrawerVehicleEntryAuthorization: boolean;
  visibleDrawerCheckinRegisterAttendance: boolean;
  visibleDrawerViewRegisterAttendance: boolean;
  visibleDrawerViewMode: DrawerStatusEnum;
  visibleModalVehicleAction: boolean;
  visibleModalReleaseVehicle: boolean;
  excludeButtonDisabled: boolean;
  formViewOrEditModified: boolean;
  disabledButton: boolean;
  items?: Array<IItems>;
  totalItems: number;
  filter: IAttendanceFilter;
  filterOptions: IAttendanceFilterOptions;
  searchFilter: string;
  vehicleStatusList: Array<IVehicleStatusList>;
  tabPaneActive: TabPaneStatusEnum;
  itemsCheckin?: IItemsCheckinDataTable[];
}

export const activeSummary = {
  presented: 0,
  averageTimePresented: null,
  released: 0,
  notReleased: 0,
  actives: 0,
  averageTimeActives: null,
  waitingInOperation: 0,
  inOperation: 0,
  finishOperation: 0,
  warningFinishOperation: 0,
  inRadiusWithCheckin: 0,
  inRadiusWithoutCheckin: 0,
};

export const vehicleStatusList = [
  {
    id: 0,
    description: "Todos",
  },
];

export const defaultState: IAttendanceState = {
  isLoading: false,
  isLoadingTable: false,
  isLoadingSummary: false,
  disabledButtonReleaseVehicle: false,
  disabledButtonSaveVehicle: false,
  visibleDrawerVehicleEntryAuthorization: false,
  visibleDrawerViewCheckinRegisterAttendance: false,
  vehicleEntryAuthorizationRegisterActive: [],
  visibleDrawerCheckinRegisterAttendance: false,
  visibleDrawerViewRegisterAttendance: false,
  visibleDrawerViewMode: DrawerStatusEnum.View,
  visibleModalVehicleAction: false,
  visibleModalReleaseVehicle: false,
  excludeButtonDisabled: false,
  formViewOrEditModified: false,
  disabledButton: false,
  activeSummaryData: activeSummary,
  vehicleStatusList: vehicleStatusList,
  tabPaneActive: TabPaneStatusEnum.Info,
  itemsCheckin: [],
  items: [],
  totalItems: 0,
  searchFilter: "",
  filter: {
    itemsByPage: 10,
    pageIndex: 1,
    orderBy: null,
  },
  filterOptions: {
    processId: [],
    saleChannelId: [],
    status: null,
  },
};
